<template>
  <div>
    <!-- Right Sidebar -->
    <div class="right-bar">
      <Network v-slot="status">
        <div class="rightbar-title">
          <a
            href="javascript:void(0);"
            class="right-bar-toggle float-right"
            @click="hide"
          >
            <i class="fe-x noti-icon fe-4x"></i>
          </a>
          <div class="user-box text-white text-left">
            <span class="user-first-name">{{ currentSession ? currentSession.user.first_name : '' }}</span><br>
            <span class="user-last-name">{{ currentSession ? currentSession.user.last_name : '' }}</span><br>
            <span class="user-username">{{ currentSession ? currentSession.user.username.toLowerCase() === currentSession.user.username.toUpperCase() ? 'C.C.' : '' : '' }} {{ currentSession ? currentSession.user.username : '' }}</span>
          </div>
        </div>
        <div clas="row">
          <SideNavMobile :toggleMenu="toggleMenu"/>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
             <span @click.prevent="logout" v-if="status.isOnline" class="btn btn-transparent btn-link mt-4 text-danger">
              <i class="fe-log-out mr-1"></i>
              CERRAR SESIÓN
            </span>
          </div>
        </div>
      </Network>
    </div>
    <!-- /Right-bar -->

    <!-- Right bar overlay-->
    <div class="rightbar-overlay" id="rightbar-overlay">
      
    </div>
  </div>
</template>

<script>
import { authComputed } from '@state/helpers'
import Network from "@plugins/Network";
import SideNavMobile from './side-nav_mobile'

export default {
  components: { Network ,SideNavMobile},
  props:{
    toggleMenu: {
      type: Function,
      required: false,
      default: () => { },
    },
  },
  computed: {
    ...authComputed,
  },
  methods: {
    hide() {
      this.$parent.toggleRightSidebar()
    },
    logout() {
      const me = this;
      me.hide();
      me.$router.push({name: 'logout'});
    },
    listeCloseMenu() {
      const me = this;
      document.addEventListener('click', (e) => {
        const typeOf = typeof e.target.className

        if (typeOf !== "object" && e.target.className.includes("rightbar-overlay")) {
          me.hide();
        }
      })
    },
  },
  mounted() {
    const me = this
    me.listeCloseMenu()
  },
}
</script>

<style lang="scss">
.right-bar {
  .user-box {
    margin-top: 20px;
    padding-left: 50px;
    line-height: 22px;
    font-family: 'Montserrat';
    .user-first-name {
      font-weight: bolder;
      font-size: 22px;
    }
    .user-last-name {
      font-weight: bolder;
      font-size: 16px;
    }
    .user-username {
      font-weight: thin;
      font-size: 16px;
    }
  }
}  
</style>
